import axios from 'axios'
import apiUtils from './apiUtils'

const apiParams = {
  baseURL: `${process.env.BASE_API_URL}/`,
}

apiParams.withCredentials = false
apiParams.transformResponse = [(data) => apiUtils.checkResponse(data)]

apiParams.validateStatus = function (status) {
  window.vm.showSpinner = false

  if (status === 401 || status === 403) {
    window.vm.$store.dispatch('users/forceLogoutUser')
    window.vm.$router.push('/auth')
  }

  if (status == 404) {
    window.vm.$router.push('/404')
  }

  if (status >= 200 && status < 400) {
    return true
  }

  return false
}

const apiCode = 'qtogvUlOHpwLC9S6wgnGuIOb5oZgsrHCvxTJ47DYm0PlwaFk4H6ueQhJ'
const apiAxios = axios.create(apiParams)

apiAxios.interceptors.request.use((config) => {
  window.vm.showSnackbar = false
  return config
})

apiAxios.interceptors.response.use((response) => {
  window.vm.showSpinner = false

  return response
})

export default {
  getApiParams() {
    return apiParams
  },
  loginUser(email, password) {
    return apiAxios.post(`/TempLogin/Login?code=${apiCode}`, { email, password })
  },
  getConfig() {
    return apiAxios.get(`/Config/GetConfigs?code=${apiCode}`)
  },
}
